import styles from './TenantSelector.module.css';
import type { TenantSyncModeSelectorProps } from './types';

export function TenantSyncModeSelector({
  allCurrentAndFuture,
  onAllMode,
  onSelectedMode,
  allTenantsSelectionDescription,
  selectedTenantsSelectionDescription,
  disabled,
}: TenantSyncModeSelectorProps) {
  return (
    <fieldset className={styles.modeOptions}>
      <label>
        <input
          type="radio"
          name="tenant-sync-mode"
          checked={allCurrentAndFuture}
          onChange={onAllMode}
          disabled={disabled}
        />
        <span>All tenants (current and new)</span>
        <span>{allTenantsSelectionDescription}</span>
      </label>
      <label>
        <input
          type="radio"
          name="tenant-sync-mode"
          checked={!allCurrentAndFuture}
          onChange={onSelectedMode}
          disabled={disabled}
        />
        <span>Selected tenants only</span>
        <span>{selectedTenantsSelectionDescription}</span>
      </label>
    </fieldset>
  );
}
